import SlideInCourseDetailsContainer from "./SlideInCourseDetailsContainer";
import { useCourseDetails } from "../../../contexts/CourseDetailsContext";

const SlideInCourseDetailsPortal = () => {
  const { isVisible, setIsVisible, onEnroll, courseData, loading, slideAnim } = useCourseDetails();

  if (!isVisible) {
    return null;
  }

  return (
    <SlideInCourseDetailsContainer
      visible={isVisible}
      slideAnim={slideAnim}
      onClose={() => setIsVisible(false)}
      onEnroll={onEnroll}
      courseData={courseData}
      loading={loading}
    />
  );
};

export default SlideInCourseDetailsPortal;
